module.exports = {
      id: "tag-usage",
      viewBox: "0 0 30.383 24.21",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#tag",
      toString: function () {
        return this.url;
      }
    }